"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SfilterKey = void 0;
var SfilterKey;
(function (SfilterKey) {
    SfilterKey[SfilterKey["PRICE"] = 0] = "PRICE";
    SfilterKey[SfilterKey["SIZE"] = 1] = "SIZE";
    SfilterKey[SfilterKey["TYPE"] = 2] = "TYPE";
    SfilterKey[SfilterKey["KEYWORD"] = 3] = "KEYWORD";
    SfilterKey[SfilterKey["BED"] = 4] = "BED";
    SfilterKey[SfilterKey["AMENITY"] = 5] = "AMENITY";
    SfilterKey[SfilterKey["DISTRICT"] = 6] = "DISTRICT";
    SfilterKey[SfilterKey["SORT"] = 7] = "SORT";
    SfilterKey[SfilterKey["LAYOUT"] = 8] = "LAYOUT";
    SfilterKey[SfilterKey["SHOWONLY"] = 9] = "SHOWONLY";
})(SfilterKey = exports.SfilterKey || (exports.SfilterKey = {}));
